<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'background-display',
    mixins: [baseOption],

    data() {
        return {
            isChecked: true,
            displayName: 'Display',

            messages: {
                checked: 'Visible',
                unchecked: 'Hidden',
            },

            tailwindDefinitionProp: 'backgroundDisplay',
        };
    },

    methods: {
        onInput(isChecked) {
            let flexClassNew;

            if (isChecked) {
                this.removeFlexClass('default');
            } else {
                flexClassNew = this.addFlexClass({});
            }

            this.isChecked = isChecked;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.isChecked = !this.flexClassGroup[this.screen].default;
        },
    },
};
</script>
